import { BrowserRouter, StaticRouter } from "react-router";
import { usePageContext } from "vike-react/usePageContext";

import AppProviders from "@/AppProviders";

export default function Layout({ children }) {
    const pageContext = usePageContext();
    const isServer = typeof window === "undefined";
    const location = pageContext?.urlPathname || pageContext?.urlOriginal || "/";

    const app = isServer ? <StaticRouter location={location}>{children}</StaticRouter> : <BrowserRouter>{children}</BrowserRouter>;

    return <AppProviders>{app}</AppProviders>;
}
